import React from "react";
import myPhoto from "../img/IMG_0098.png";
import bookIcon from "../img/book-solid.svg";
import travelIcon from "../img/plane-solid.svg";
import gameIcon from "../img/baseball-bat-ball-solid.svg";
import Skill from "./Skill";
import Projects from "./Projects";
import ContactForm from "./ContactForm";

const Home = () => {
  return (
    <div>
      {/* home */}
      <div className="hero min-h-screen bg-gradient-to-r from-slate-200 to-red-200">
        <div className="hero-content w-full flex-col lg:flex-row-reverse justify-between">
          <div className=" lg:p-20">
            <img
              src={myPhoto}
              className="max-w-sm rounded-full shadow-2xl"
              alt=""
            />
          </div>

          <div className="text-left p-10">
            <h1 className="text-5xl font-bold">Abdullah </h1>
            <h1 className="text-5xl font-bold">Al Noman</h1>
            <ul className="text-left py-6 ">
              <li className="text-slate-400 leading-loose">
                FULL-STACK WEB DEVELOPER
              </li>
              <li className="leading-loose">
                <img className="w-4 inline" src={bookIcon} alt="" />
                <span className="px-2">Read Book</span>
              </li>
              <li className="leading-loose">
                <img className="w-5 inline" src={travelIcon} alt="" />
                <span className="px-2">TRAVEL</span>
              </li>
              <li className="leading-loose">
                <img className="w-5 inline" src={gameIcon} alt="" />
                <span className="px-2">VIDEO GAME ENTHUSIAST</span>
              </li>
            </ul>
            <div className=" p-5 text-left border border-slate-800 rounded-lg">
              <h4 className="pb-3 font-bold text-2xl">A little about me </h4>
              <p className=" text-slate-700">
                Front-end web developer, teaching assistant, and the Full-Stack
                JavaScript program , working on making it my career. Experienced
                in: JavaScript, React.js, Node.js, HTML, CSS, JSON, APIs,
                MongoDB, and Express. I love to learn, I love to help people,
                and I would love to do both with a career in development. I have
                a great passion for music - listening to it, practicing my
                programming knowledge, and reading book. And I am a lifelong
                lover of video games in general.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Skill */}
      <Skill></Skill>

      {/* Projects */}
      <Projects></Projects>

      {/* contact me  */}
      <ContactForm></ContactForm>
    </div>
  );
};

export default Home;
